// Link preview service using backend API
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export const fetchLinkPreview = async (url) => {
  try {
    // Basic URL validation
    const urlObj = new URL(url);
    
    // Call backend API to get link preview
    const response = await fetch(`${API_BASE}/api/links/preview?url=${encodeURIComponent(url)}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const preview = await response.json();
    return preview;
    
  } catch (error) {
    console.error('Error fetching link preview:', error);
    
    // Fallback to basic preview if backend fails
    try {
      const urlObj = new URL(url);
      const domain = urlObj.hostname;
      
      return {
        title: domain,
        description: `Link from ${domain}`,
        image: null,
        favicon: `https://www.google.com/s2/favicons?domain=${domain}&sz=32`,
        domain: domain,
        url: url
      };
    } catch (e) {
      return {
        title: url,
        description: 'Invalid URL',
        image: null,
        favicon: null,
        domain: 'unknown',
        url: url
      };
    }
  }
};

// Helper function to validate URLs
export const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};
